import { Checkbox, InfoLabel, SearchInput } from '../../../common/components';

const Toolbar = ({
  title,
  subTitle,
  subSubTitle,
  optionOneLabel,
  optionOneIcon,
  onOptionOneClick,
  optionTwoLabel,
  optionTwoIcon,
  onOptionTwoClick,
  optionThreeLabel,
  optionThreeIcon,
  onOptionThreeClick,
  isSearchable = false,
  searchText,
  onSerchInputChange,
  SearchInputPlaceholder,
  isTableDataPresent,
  requiredSelectAll,
  onSelectAllClick,
  selectAll,
  requiredSelectDue,
  onSelectDueClick,
  selectDue,
  totalCount,
  toolTipText,
  module,
}) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
        className="row toolbar-row"
      >
        {requiredSelectDue && (
          <div style={{ marginTop: '5px', marginLeft: '50px' }}>
            <Checkbox
              name="dueCheckbox"
              simple
              onChange={onSelectDueClick}
              checked={selectDue}
              label={selectDue ? 'Showing records with Due' : 'Select Records with Due'}
              labelPosition="right"
            />
          </div>
        )}
        <div className="aging-report-title">
          {title && <InfoLabel showIcon label={title} toolTipText={toolTipText} module={module} />}
          {subTitle && (
            <div className="aging-report-subtitle">
              <InfoLabel label={subTitle} size="12px" weight="0" />
            </div>
          )}
          {subSubTitle && (
            <div className="aging-report-subtitle">
              <InfoLabel label={subSubTitle} size="12px" weight="0" />
            </div>
          )}
        </div>
        {isSearchable && (
          <div className="d-flex search-toolbar p-0">
            <SearchInput
              placeholder={SearchInputPlaceholder}
              searchText={searchText}
              handleChange={onSerchInputChange}
            />
          </div>
        )}
        {requiredSelectAll && (
          <div className="bulk-select-btn">
            <p onClick={onSelectAllClick}>
              {selectAll
                ? 'Clear Selection'
                : totalCount
                  ? ` Select all ${totalCount} records`
                  : null}
            </p>
          </div>
        )}
        <div className={isTableDataPresent ? 'aging-report-toolbar p-0' : 'cursor-default'}>
          {optionOneLabel && (
            <InfoLabel
              showIcon
              label={optionOneLabel}
              iconLocation="Left"
              iconType={optionOneIcon}
              onClick={onOptionOneClick}
            />
          )}
          {optionTwoLabel && (
            <>
              <div className="hr-r" />
              <InfoLabel
                showIcon
                label={optionTwoLabel}
                iconLocation="Left"
                iconType={optionTwoIcon}
                onClick={onOptionTwoClick}
              />
            </>
          )}
          {optionThreeLabel && (
            <>
              <div className="hr-r" />
              <InfoLabel
                showIcon
                label={optionThreeLabel}
                iconLocation="Left"
                iconType={optionThreeIcon}
                onClick={onOptionThreeClick}
              />
            </>
          )}
        </div>
      </div>
      <hr />
    </>
  );
};

export default Toolbar;
